import axios from "axios";

const url = "/distributor/admin/api/v1/checkout/list";
export function getCheckoutList(parameters) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, {
        length: parameters.length,
        start: parameters.start,
        order: parameters.order,
        order_by: parameters.order_by,
        filter: {
          search: parameters.filter.search,
          remark_search: parameters.filter.remark,
          serialnumber_search: parameters.filter.serialnumber_search,
          from_date: parameters.filter.from_date,
          to_date: parameters.filter.to_date,
          nodes: parameters.filter.nodes,
          checkout_by: parameters.filter.checkout_by,
          product_uuid: parameters.filter.product_uuid,
        },
      })
      .then((response) => resolve(response.data))
      .catch((error) => reject(error.response.data));
  });
}
